import { chatStoreReducer } from '@/store/reducers/ChatStore';
import { conversationSlice } from '@/components/paper-finder/shared/store/endpoints/threads';
import { dataVoyagerWidgetStoreReducer } from '@/store/reducers/DataVoyagerWidgetStore';
import { paperFinderReactionsApi } from '@/components/paper-finder/shared/store/endpoints/reactions';
import { paperFinderResultSetApi } from '@/components/paper-finder/shared/store/endpoints/result-set';
import { paperFinderStateApi } from '@/components/paper-finder/shared/store/endpoints/widget-state';
import { paperFinderWidgetSlice } from '@/store/reducers/PaperFinderWidgetStore';
import { readerWidgetStoreReducer } from '@/store/reducers/ReaderWidgetStore';
import { reportWidgetStoreReducer } from '@/store/reducers/ReportWidgetStore';
import { stepProgressStoreReducer } from '@/store/reducers/StepProgressStore';
import { tableRecommendationsStoreReducer } from '@/store/reducers/TableRecommendationsStore';
import { tableWidgetStoreReducer } from '@/store/reducers/TableWidgetStore';
import { toastStoreReducer } from '@/store/reducers/ToastStore';
import { UIStateReducer } from '@/store/reducers/UIState';
import { userStoreReducer } from '@/store/reducers/UserStore';

import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

export const store = configureStore({
  reducer: {
    chatStore: chatStoreReducer,
    dataVoyagerWidgetStore: dataVoyagerWidgetStoreReducer,
    readerWidgetStore: readerWidgetStoreReducer,
    tableWidgetStore: tableWidgetStoreReducer,
    tableRecommendationsStore: tableRecommendationsStoreReducer,
    reportWidgetStore: reportWidgetStoreReducer,
    stepProgressStore: stepProgressStoreReducer,
    toastStore: toastStoreReducer,
    UIState: UIStateReducer,
    userStore: userStoreReducer,
    [conversationSlice.reducerPath]: conversationSlice.reducer,
    [paperFinderStateApi.reducerPath]: paperFinderStateApi.reducer,
    [paperFinderWidgetSlice.reducerPath]: paperFinderWidgetSlice.reducer,
    [paperFinderReactionsApi.reducerPath]: paperFinderReactionsApi.reducer,
    [paperFinderResultSetApi.reducerPath]: paperFinderResultSetApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(paperFinderStateApi.middleware)
      .concat(paperFinderReactionsApi.middleware)
      .concat(paperFinderResultSetApi.middleware),
});

// required for redux toolkit queries to work
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
